import { render, staticRenderFns } from "./Brik.vue?vue&type=template&id=2c3d3d4a&"
import script from "./Brik.vue?vue&type=script&lang=js&"
export * from "./Brik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports